import { useGomakeTheme } from "@/hooks/use-gomake-thme";
import { useMemo } from "react";
import { FONT_FAMILY } from "@/utils/font-family";
import { convertWidthToVW, leftRightAdapter } from "@/utils/adapter";
import { useTranslation } from "react-i18next";

const useStyle = () => {
  const { theme, primaryColor } = useGomakeTheme();
  const { t } = useTranslation();
  const classes = useMemo(() => {
    return {
      container: {
        display: "flex",
        alignItems: "center" as "center",
        justifyContent: "space-between" as "space-between",
        width: "100%",
        gap: 12,
      },
      leftGroup: {
        display: "flex",
        alignItems: "center" as "center",
        gap: 12,
        flexWrap: "wrap" as "wrap",
        minWidth: 0,
      },
      rightActions: {
        display: "flex",
        gap: 10,
        alignItems: "center" as "center",
        flexShrink: 0,
        marginInlineStart: "auto",
      },
      searchInput: {
        maxWidth: 335,
        height: 40,
        width: convertWidthToVW(375),
        backgroundColor: "#F8F8F8",
        borderRadius: 10,
      },
      switchLabel: {
        ...FONT_FAMILY.Lexend(400, 12),
        color: primaryColor(9800),
        minWidth: "fit-content" as "fit-content",
      },
      iconStyle: {
        position: "absolute" as "absolute",
        ...leftRightAdapter(t("direction"), 16),
        top: 10,
      },
    };
  }, [theme]);
  return {
    classes,
  };
};
export { useStyle };
